/**
 * Experiment type - determines which identifier is used for calculation.
 */
export const EXPERIMENT_TYPE = {
    GUEST: 'guest',
    USER: 'user'
} as const;

/**
 * All possible experiment states.
 */
export const EXPERIMENT_STATE = {
    ACTIVE: 'active',
    LOCKED: 'locked',
    DISABLED: 'disabled'
} as const;
